import React, { useEffect, useState } from "react";
import { Modal, Form, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { save } from "../../../../../features/save/saveSlice";
import toast from "react-hot-toast";
import Gradient from "../../../../../assets/svg/Gradient.svg";
import PaymentSummary from "../PaymentSummary";
import PaymentMethod from "../PaymentMethod";
import AmountToPay from "../AmountToPay";
import AirtimeHeader from "../AirtimeHeader";
import PurchaseType from "../PurchaseType";
import Details from "../Details";

const AirtimeModal = ({ isModalOpen, handleCancel }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { saving } = useSelector((state) => state.save);
  const [step, setStep] = useState(1);
  const [billAmount, setBillAmount] = useState(null);
  const [loading, setLoading] = useState(false);


  const handleProceed = async () => {
    try {
      // Validate phone number and amount fields
      await form.validateFields(["phoneNumber", "amount"]);

      const values = form.getFieldsValue(["phoneNumber", "amount"]);

      // Use the amount from Details form
      const amount = values.amount;
      setBillAmount(amount);
      form.setFieldsValue({ editableAmount: amount });
      setStep(2);
    } catch (error) {
      console.log("Validation failed:", error);
    }
  };

  const handleModalCancel = () => {
    setStep(1);
    setBillAmount(null);
    form.resetFields();
    handleCancel();
  };

  const onFinish = async (data) => {
    const res = await dispatch(
      save({ ...data, url: "api/v1/payments/save-payment-category" })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await handleModalCancel();
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  return (
    <Modal
      open={isModalOpen}
      onCancel={handleModalCancel}
      width="30rem"
      footer={null}
      closeIcon={null}
      className="electricity-modal"
      zIndex={9999}
      styles={{
        body: {
          position: "relative",
        },
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          backgroundImage: `url(${Gradient})`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "top right",
          backgroundSize: "100% auto",
          pointerEvents: "none",
          zIndex: 0,
        }}
      />
      <Form
        layout="vertical"
        form={form}
        onFinish={onFinish}
        style={{ position: "relative", zIndex: 1 }}
      >
        <Spin spinning={loading}>
          {step === 1 ? (
            <>
              <AirtimeHeader />
              <PurchaseType form={form} />
              <Details
                form={form}
                handleCancel={handleModalCancel}
                handleProceed={handleProceed}
              />
            </>
          ) : (
            <>
              <PaymentSummary
                phoneNumber={form.getFieldValue("phoneNumber")}
                purchaseType={form.getFieldValue("purchaseType")}
              />
              <AmountToPay amount={billAmount} form={form} />
              <PaymentMethod form={form} handleModalCancel={handleModalCancel} />
            </>
          )}
        </Spin>
        
      </Form>
    </Modal>
  );
};

export default AirtimeModal;
